import React, { useState, useEffect } from "react";
import { Card } from "reactstrap";
import CustomModal from "../../../../Components/Modals/CustomModal";

function NotificationPayload({isOpen,toggle,selectedPayload,notificationType}) {
    const [expandedSections, setExpandedSections] = useState({});

    useEffect(() => {
        setExpandedSections({});
    }, [selectedPayload, notificationType]);

    const toggleSection = (key) => {
        setExpandedSections(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const isExpanded = (key) => {
        return expandedSections[key] === true;
    };

    const topLevelSections = {
        ANY_OFFER_CHANGED: [
            /^Offers\s+\d+$/i,
            /^Summary$/i,
            /^Offer Change Trigger$/i
        ],
        B2B_ANY_OFFER_CHANGED: [
            /^Offers\s+\d+$/i,
            /^Summary$/i,
            /^Offer Change Trigger$/i
        ],
        FBA_INVENTORY_AVAILABILITY_CHANGES: [
            /^Fulfillment Inventory By Marketplace\s+\d+$/i
        ],
        ORDER_CHANGE: [
            /^Summary$/i,
            /^Order Change Trigger$/i
        ],
        PRICING_HEALTH: [
            /^Summary$/i,
            /^Merchant Offer$/i,
            /^Offer Change Trigger$/i
        ],
        ACCOUNT_STATUS_CHANGED: [
            /^Account Status Change Notification$/i
        ]
    };

    const isTopLevelSection = (label) => {
        const patterns =
            topLevelSections[notificationType] || [];
        return patterns.some(pattern =>
            pattern.test(String(label))
        );
    };

    const Arrow = ({ open }) => (
        <span
            className={`notification-payload-arrow ${
                open ? "arrow-open" : "arrow-closed"
            }`}
        />
    );

    const SectionHeader = ({
        label,
        sectionKey
    }) => {
        const open = isExpanded(sectionKey);

        return (
            <div
                onClick={() => toggleSection(sectionKey)}
                className="notification-payload-section-header d-flex justify-content-between align-items-center"
            >
                <span>
                    {label}
                </span>
                <Arrow open={open} />
            </div>
        );
    };

    const ValueRow = ({ item }) => {
        return (
            <div className="notification-payload-value-row">
                {item.label && item.label !== ":" && (
                    <b>{item.label}: </b>
                )}

                {item.value !== null &&
                item.value !== undefined &&
                item.value !== ""
                    ? String(item.value)
                    : "-"}
            </div>
        );
    };

    const ChildHeader = ({ label }) => {
        return (
            <div className="notification-payload-child-header">
                {label}
            </div>
        );
    };

    const createSections = () => {
        const sections = [];
        let currentSection = null;
        selectedPayload.forEach((item) => {
            if (
                item.isHeader &&
                isTopLevelSection(item.label)
            ) {
                currentSection = {
                    label: item.label,
                    items: []
                };
                sections.push(currentSection);

            } else if (currentSection) {
                currentSection.items.push(item);
            } else {
                sections.push({
                    label: null,
                    items: [item]
                });
                currentSection =
                    sections[sections.length - 1];
            }
        });
        return sections;
    };

    const renderOfferSection = (
        section,
        sectionIndex
    ) => {

        const sectionKey =
            `offer-${sectionIndex}`;

        const open =
            isExpanded(sectionKey);

        return (
            <div
                key={sectionKey}
                className="notification-payload-section mb-2 border rounded"
            >
                <SectionHeader
                    label={section.label}
                    sectionKey={sectionKey}
                />
                {open && (
                    <div className="notification-payload-content">
                        {section.items.map(
                            (item, index) => {
                                if (item.isHeader) {
                                    return (
                                        <ChildHeader
                                            key={index}
                                            label={item.label}
                                        />
                                    );
                                }
                                return (
                                    <ValueRow
                                        key={index}
                                        item={item}
                                    />
                                );
                            }
                        )}
                    </div>
                )}
            </div>
        );
    };

    const renderAccountStatusChanged = () => {
        return (
            <div className="notification-payload-section border rounded">
                <div className="notification-payload-static-header">
                    Account Status Change Notification
                </div>
                <div className="notification-payload-content">
                    {selectedPayload.map((item, index) => {
                        if (
                            item.isHeader &&
                            item.label === "Account Status Change Notification"
                        ) {
                            return null;
                        }
                        if (item.isHeader) {
                            return (
                                <ChildHeader
                                    key={index}
                                    label={item.label}
                                />
                            );
                        }
                        return (
                            <ValueRow
                                key={index}
                                item={item}
                            />
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderNormalSection = (
        section,
        sectionIndex
    ) => {
        if (!section.label) {
            return section.items.map(
                (item, index) => {
                    if (item.isHeader) {
                        return (
                            <ChildHeader
                                key={index}
                                label={item.label}
                            />
                        );
                    }
                    return (
                        <ValueRow
                            key={index}
                            item={item}
                        />
                    );
                }
            );
        }

        const sectionKey =
            `section-${sectionIndex}`;

        const open =
            isExpanded(sectionKey);

        return (
            <div
                key={sectionKey}
                className="notification-payload-section mb-2 border rounded"
            >
                <SectionHeader
                    label={section.label}
                    sectionKey={sectionKey}
                />
                {open && (
                    <div className="notification-payload-content">
                        {section.items.map(
                            (item, index) => {
                                if (item.isHeader) {
                                    return (
                                        <ChildHeader
                                            key={index}
                                            label={item.label}
                                        />
                                    );
                                }
                                return (
                                    <ValueRow
                                        key={index}
                                        item={item}
                                    />
                                );
                            }
                        )}
                    </div>
                )}
            </div>
        );
    };

    if (
        !Array.isArray(selectedPayload) ||
        selectedPayload.length === 0
    ) {

        return (
            <CustomModal
                isOpen={isOpen}
                toggle={toggle}
                size="lg"
                header="Notification Payload"
                className="curve-popup"
            >
                <Card className="curve-popup p-3">
                    No Payload Found
                </Card>
            </CustomModal>
        );
    }

    if (notificationType === "ACCOUNT_STATUS_CHANGED") {
        return (
            <CustomModal
                isOpen={isOpen}
                toggle={toggle}
                size="lg"
                header="Notification Payload"
                className="curve-popup"
            >
                <Card className="curve-popup p-3">
                    <div className="notification-payload-container">
                        {renderAccountStatusChanged()}
                    </div>
                </Card>
            </CustomModal>
        );
    }

    const sections = createSections();
    return (
        <CustomModal
            isOpen={isOpen}
            toggle={toggle}
            size="lg"
            header="Notification Payload"
            className="curve-popup"
        >
            <Card className="curve-popup p-3">
                <div className="notification-payload-container">
                    {sections.map(
                        (section, index) => {
                            if (
                                notificationType ===
                                    "ANY_OFFER_CHANGED" ||
                                notificationType ===
                                    "B2B_ANY_OFFER_CHANGED"
                            ) {
                                if (
                                    section.label &&
                                    /^Offers\s+\d+$/i.test(
                                        section.label
                                    )
                                ) {
                                    return renderOfferSection(
                                        section,
                                        index
                                    );
                                }
                            }
                            return renderNormalSection(
                                section,
                                index
                            );
                        }
                    )}
                </div>
            </Card>
        </CustomModal>
    );
}

export default NotificationPayload;